import { Trans } from '@lingui/react/macro';
import { Medal } from '@remarkable/ark-icons';
import { Typography } from '@remarkable/ark-web';

export const FreeConnectDetails = () => {
  return (
    <div data-cy="free-connect-details">
      <div className="mb-24 flex items-center gap-8">
        <Medal size={28} />
        <Typography variant="interface-sm" leadingNone className="uppercase">
          <Trans>Free access</Trans>
        </Typography>
      </div>
      <Typography variant="body-sm">
        <Trans>
          As one of our valued early customers, you have full free access to
          Connect. This is our way to thank you for believing in us from the
          start. Enjoy unlimited cloud storage, seamless integrations,
          handwriting search, and a growing list of tools built to suit your
          workflow.
        </Trans>
      </Typography>
    </div>
  );
};
